// @flow
import React, { Component }  from "react";
import { Route, Switch } from "react-router-dom";
import GroupsView from "../views/GroupsView";
import ProductsView from "../views/ProductsView";
import ProductView from "../views/ProductView";
import NearbyConsultants from "../views/NearbyConsultantsView";
import ContactRepView from "../views/ContactRepView";
import FourOhFourView from "../views/FourOhFourView";


class AppCatalogueRoutes extends Component {
    render() {
        return (
            <Switch>
                <Route exact path="/:shopName?/categories/:id/" component={ProductsView} />
                <Route exact path="/:shopName?/categories/" component={GroupsView} />
                <Route exact path="/:shopName?/products/:id/" render={(props) => <ProductView {...props} showTitle={true} />} />
                <Route exact path="/:shopName?/nearby-consultants/" component={NearbyConsultants} />
                <Route exact path="/:shopName?/contactrep/" component={ContactRepView} />
                <Route exact path="/:shopName?/search/:searchTerm/" render={(props) => <ProductsView {...props} showTitle={true} isSearch={true} />} />
                <Route exact path="/:shopName?" component={GroupsView} />
                <Route component={FourOhFourView} />
            </Switch>
        );
    }
}
export default AppCatalogueRoutes
